'use client';
/* Built In Imports */
import { Suspense, useEffect, useRef } from 'react';

/* External Imports */
import { ChakraProvider, Skeleton } from '@chakra-ui/react';
import TagManager from 'react-gtm-module';

/* Internal Imports */
/* Components */
import BuildTimeComment from '@app-ila/components/Utility/BuildTimeComment';
import Layout from '@app-ps/Components/Layout/Layout';
import SamskritiContextProvider from '@app-ps/Store/samskriti-context';
import AuthContextProvider from '@store/auth-context';
import { mixPanel } from '@utils/Mixpanel';

/* Services */
/* Styles */
import { ishaTheme } from '@app-ps/theme';
import '@app-ps/theme/global-ps.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/**
 * @param Component
 * @param pageProps
 */

const Providers = ({ children }) => {
  const firstUpdate = useRef(true);

  const tagManagerArgs = {
    gtmId: 'GTM-5G2NJ8P',
  };

  useEffect(() => {
    // Mixpanel
    const Mixpanel = mixPanel(
      window?.location.pathname,
      process?.env?.NEXT_PUBLIC_BUILDTYPE
    );

    if (Object.keys(Mixpanel)?.length > 0) {
      // console.log('mixpanel load starts', Mixpanel, window?.location.pathname);

      const mixPanelPageViewObj = {
        page_name: window?.document?.title,
      };

      // Track page views
      Mixpanel.track('samskriti_pageview', mixPanelPageViewObj);
    }
    // Mixpanel

    setTimeout(function () {
      if (firstUpdate.current) {
        if (process.browser) {
          TagManager.initialize(tagManagerArgs);
        }
        firstUpdate.current = false;
      } else {
        // consoleLog('GTM pushed to data layer', window.location.href);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'Pageview',
          url: window.location.href,
          title: window.document.title,
        });
      }
    }, 1500);
  }, []);

  return (
    <AuthContextProvider>
      <SamskritiContextProvider>
        <ChakraProvider resetCSS theme={ishaTheme}>
          <Suspense fallback={<Skeleton />}>
            <Layout>{children}</Layout>
          </Suspense>
        </ChakraProvider>
        <BuildTimeComment />
      </SamskritiContextProvider>
    </AuthContextProvider>
  );
};

export default Providers;
